module.exports = __webpack_public_path__ + "img/bbb0.cfa0464b.gif";